import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { hasPurchaseMotionsFailedSelector } from '../../../selectors/LoadingStateSelectors'; // When an error state is decoupled from the catch-all hasPricingAndPurchasingFailed selector
// We can pull in the individual fail state here and surface specific language to users

const FallbackErrorBanner = () => {
  const hasPurchaseMotionsFailed = useSelector(hasPurchaseMotionsFailedSelector);

  if (hasPurchaseMotionsFailed) {
    return /*#__PURE__*/_jsx(UIAlert, {
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "failedPurchaseMotionsBanner.title"
      }),
      type: "danger",
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "failedPurchaseMotionsBanner.description"
      })
    });
  }

  return null;
};

export default FallbackErrorBanner;